export const SupportingImageType = [
  "png",
  "jpeg",
  "jpg",
  "gif",
  "svg",
  "tiff",
  "bmp",
]
